<template>
    <div class="call-config-settings">
        <auto-form class="mx-2 mx-xl-auto w-xl-50"
                   :columns="fields"
                   :errors="errors"
                   field-class="col-sm-6 pt-2"
                   label-class="col-sm-6 col-form-label"
                   v-model="model"></auto-form>
        <div class="text-center mb-5">
            <save-button label="Save Settings"
                         @click.prevent="save"
                         :loading="loading"
                         :success="showSuccess"></save-button>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';
    import AutoForm from '../../components/DataGrid/AutoForm';
    import { Formatters } from '../../common/formatters';
    import { PickList } from '../../components/DataGrid/AutoForm';
    import SaveButton from '../../components/SaveButton';

    export default {
        emits: ['update'],
        props: ['callConfig', 'errors', 'loading'],
        components: {
            AutoForm,
            SaveButton,
        },
        data: function () {
            return {
                model: {},
                showSuccess: false,
            }
        },
        computed: {
            fields() {
                return [
                    {
                        name: 'locationName',
                        label: 'Location Name',
                        description: 'The name used to identify this location',
                    }, {
                        name: 'locationNameShort',
                        label: 'Name (short)',
                        description: 'The name used by the AI when referring to this location. It can be a shorter, more concise description.',
                        style: { 'max-width': '10em' },
                        innerClass: 'text-truncate',
                    }, {
                        name: 'inboxName',
                        label: 'Inbox Label',
                        description: 'The label used for the Inbox if you have multiple locations.',
                        style: { 'max-width': '10em' },
                        innerClass: 'text-truncate',
                    }, {
                        name: 'forwardMessagesToMembers',
                        label: 'Forward All Messages',
                        description: 'All text messages sent to this number will be sent to the other members of this group chat.  When off, only the group owners get these messages.',
                        type: 'bool',
                        formatter: Formatters.onoff,
                        hiddenWhen(config) { return !config.featureGroupChat; },
                    }, {
                        name: 'localTimeZone',
                        label: 'Time Zone',
                        description: 'The local time zone for this location.',
                        type: 'dropdown',
                        style: { 'max-width': '10em' },
                        innerClass: 'text-truncate',
                        required: true,
                        options: PickList.timeZones
                    }, {
                        name: 'website',
                        label: 'Website',
                        description: 'The website for this location.',
                    }, {
                        name: 'aiName',
                        label: 'AI Name',
                        description: 'The name that the AI will use to identify itself to users.',
                    }, {
                        name: 'aiModel',
                        label: 'Model',
                        description: 'The LLM that the AI will use. This will also be the base model for fine-tuning custom models.',
                        type: 'dropdown',
                        options: PickList.aiModels,
                    }, {
                        name: 'customModel',
                        label: 'Custom Model',
                        editable: false,
                        description: 'This is the ID of a fine-tuned model. Typically the system sets this for you after model training is complete.',
                    }, {
                        name: 'sampling',
                        label: 'Creativity',
                        description: 'Changes how creative the AI will be in it\'s responses.  A lower value is more rigid. A higher value is more creative and less predictable.',
                        type: 'range',
                        range: ['0.1', '1.0'],
                        step: '0.1',
                        defaultValue: 1,
                        required: true,
                    }, {
                        name: 'announceAI',
                        label: 'Announce as AI',
                        description: 'When turned on, the AI will let the user know they are communicating with an AI.',
                        type: 'bool',
                        formatter: Formatters.onoff,
                    }, {
                        name: 'businessHours',
                        label: 'Business Hours',
                        description: 'A plain english description of this location\'s hours of operation.',
                    }, {
                        name: 'emailNotificationOfChats',
                        label: 'Chat Notifications',
                        description: 'Send chat notifications to the number and/or email address below.',
                        type: 'bool',
                        formatter: Formatters.onoff,
                    }, {
                        name: 'callbackTextNumber',
                        label: 'Notification Phone Number',
                        description: 'Send text (SMS) notifications to this number of conversations or requests for a call back.',
                        type: 'tel',
                    }, {
                        name: 'notificationEmail',
                        label: 'Notification Email',
                        description: 'Send notifications to this email address of conversations or requests for a call back.',
                        type: 'email',
                    }, {
                        name: 'digestNotifications',
                        label: 'Digest Notifications',
                        description: 'Send an email summary of conversations approximately every 15 minutes instead of one email per conversation.',
                        type: 'bool',
                        formatter(value) { return Formatters.yesno(value).toUpperCase() },
                    },
                ];
            },
            loadingClass() {
                return this.loading ? '' : ' invisible';
            },
            saveButtonClass() {
                return this.showSuccess ? 'btn btn-success opacity-100' : 'btn btn-primary';
            }
        },
        methods: {
            save() {
                this.$emit('update', this.model);
            },
            success() {
                const vm = this;
                vm.showSuccess = true;
                setTimeout(() => {
                    vm.showSuccess = false;
                }, 5000);
            },
        },
        created() {
            this.model = _.cloneDeep(this.callConfig ?? {});
        },
        watch: {
            callConfig(value) {
                this.model = _.cloneDeep(value ?? {});
            }
        }
    }
</script>